var locale = {
  placeholder: 'समय का चयन करें'
};
export default locale;
//# sourceMappingURL=hi_IN.js.map
